import React from "react";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { StateProvider } from "./Components/ContextAPI/StateProvider";
import reducer, { initialState } from "./Components/ContextAPI/reducer";

const root = createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <StateProvider initialState={initialState} reducer={reducer}>
      <App />
    </StateProvider>
  </HashRouter>
);

reportWebVitals();
